export default "__VITE_ASSET__nV0EuBkC__"